import type { FC } from "react";
import type { Player } from "../../../../../../types/teams.types";
import { useIsViewerJourney } from "../../../../../viewer-feed/viewer-journey.context";
import * as CSS from "./formation-grid.styles";

type FormationGridProps = {
	formation: string;
	players: Player[];
};

const FormationGrid: FC<FormationGridProps> = ({ formation, players }) => {
	const rows = `1-${formation}`.split("-");

	const isViewer = useIsViewerJourney();

	const playersByLine = players.reduce<Record<number, Player[]>>(
		(acc, player) => {
			if (!player.grid) return acc;
			const [line] = player.grid.split(":").map(Number);
			if (!acc[line]) {
				acc[line] = [];
			}
			acc[line].push(player);
			return acc;
		},
		{},
	);

	Object.values(playersByLine).forEach((linePlayers) => {
		linePlayers.sort(
			(a, b) => Number(a.grid?.split(":")[1]) - Number(b.grid?.split(":")[1]),
		);
	});

	const renderPlayerCells = (lineNumber: number) =>
		(playersByLine[lineNumber] ?? []).map((player) => (
			<CSS.PlayerContainer key={player.id}>
				<CSS.PlayerCell>{player.number}</CSS.PlayerCell>
				<CSS.PlayerName>{player.name.split(".")[1]?.trim()}</CSS.PlayerName>
			</CSS.PlayerContainer>
		));

	if (!rows.length) {
		return null;
	}

	return (
		<CSS.GridContainer $isViewer={isViewer}>
			<CSS.FormationBackgroundImage
				src="/assets/formations/formation-grid.png"
				alt="Formation grid"
			/>
			<CSS.RowsContainer>
				{rows.map((_, index) => (
					<CSS.GridRow
						$numRows={rows.length - 1}
						$rowIndex={index}
						key={`row-${
							// biome-ignore lint/suspicious/noArrayIndexKey: There is no other identifyer
							index
						}`}
					>
						{renderPlayerCells(index + 1)}
					</CSS.GridRow>
				))}
			</CSS.RowsContainer>
		</CSS.GridContainer>
	);
};

export default FormationGrid;
